import { useEffect, useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion
} from "./base/BaseQuestion";

import { Form } from "antd";
import { StepButton } from "./step-button";

export const Section2 = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 2;
  const [nextStep, setNextStep] = useState();
  const [isUsedMRT, setUsedMRT] = useState(false);
  const [isUsedMRT1, setUsedMRT1] = useState(false);
  const truoc = <div><span className=" font-semibold text-green-600">TRƯỚC</span> thời điểm các tuyến metro thí điểm</div>;
  const sau = <div><span className=" font-semibold text-green-600">SAU</span> thời điểm các tuyến metro thí điểm</div>;

  const renderTable = () => {
    return (
      <>
        <p className="text-right italic">Đơn vị: VND</p>
        <table className="table-auto border-collapse w-full">
          <thead>
            <tr>
              <th className="border-t-2 border-solid border-gray-500"></th>
              <th className="border-t-2 border-solid border-gray-500">
                Vé lượt
              </th>
              <th className="border-t-2 border-solid border-gray-500">
                Vé ngày (Nhiều lần)
              </th>
              <th className="border-t-2 border-solid border-gray-500">
                Vé tháng
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-y-[1px] border-dashed border-gray-500">
                MRT
              </td>
              <td className="border-y-[1px] border-dashed border-gray-500">
                8,000 – 15,000
              </td>
              <td className="border-y-[1px] border-dashed border-gray-500">
                30,000
              </td>
              <td className="border-y-[1px] border-dashed border-gray-500">
                200,000
              </td>
            </tr>
            <tr>
              <td className="border-b-2  border-solid border-gray-500">BRT</td>
              <td className="border-b-2 border-solid border-gray-500">7,000</td>
              <td className="border-b-2 border-solid border-gray-500">
                55,000 - 100,000
              </td>
              <td className="border-b-2  border-solid border-gray-500"></td>
            </tr>
          </tbody>
        </table>
        <p className="text-center italic">
          Bảng 5.1: Giá vé hiện tại của hệ thống MRT/BRT
        </p>
      </>
    );
  };
  const renderDescription = () => {
    return (
      <div>

        <p>
          Trong phần này, Anh/Chị sẽ trả lời về thói quen di chuyển hàng ngày đối với các <b>chuyến đi chính (đi học/đi làm)</b>. Cụ thể, nó sẽ đánh giá ảnh hưởng từ việc áp dụng <b>chương trình 15 ngày khai thác miễn phí</b> của các tuyến metro tới thói quen di chuyển của Anh/Chị.
        </p>
        <b>(*) Lưu ý:</b>
        <ul class="custom-list">
          <li><i>Phần trả lời này chỉ tính tới <b>trải nghiệm gần nhất</b> (Nếu Anh/Chị đã từng tham gia trải nghiệm 15 ngày khai thác miễn phí của cả 2 tuyến metro hiện tại).</i></li>
          <li><i>Những người <b>chưa từng tham gia</b> trải nghiệm 15 ngày khai thác miễn phí cũng hoàn thành phần câu hỏi này.</i></li>
          <li><i>Các câu hỏi dưới đây chỉ tính tới các <b>chuyến đi chính</b>.</i></li>
        </ul>
        {/* {renderTable()} */}
      </div>
    );
  };
  return (
    <div className="text-left" style={{ textAlign: "justify" }}>
      <Title index={majorIndex} content={title} />
      {renderDescription()}
      <Form
        onFinish={(value) => handleSubmit(value, nextStep)}
        onFinishFailed={handleFail}

      >
        <br />
        <p>Anh/Chị vui lòng đọc kỹ và trả lời các câu hỏi sau:</p>

        <b>Các câu hỏi phía dưới liên quan tới thời điểm <span className=" font-semibold text-green-600">TRƯỚC và SAU</span> khi các tuyến metro thí điểm <span className=" font-semibold text-green-600">15 ngày khai thác miễn phí:</span></b>

        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={1}
          question={"Phương tiện di chuyển cho các chuyến đi chính hàng ngày?"}
        />


        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}
                  question={truoc}
                  rawQuestion="Phương tiện di chuyển cho các chuyến đi chính hàng ngày?(TRƯỚC)"
                  answers={[
                    "Ô-tô", "Xe máy", "Xe đạp điện", "Xe đạp", "Xe bus", "Metro", "Dịch vụ gọi xe", "Đi bộ"
                  ]}
                  onChange={(value) => {
                    console.log("Phương tiện được chọn:", value);
                    if (value === "Xe máy" || value === "Ô-tô") {
                      setUsedMRT(true);
                    } else {
                      setUsedMRT(false);
                    }
                  }}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={sau}
                  rawQuestion="Phương tiện di chuyển cho các chuyến đi chính hàng ngày?(SAU)"
                  answers={[
                    "Ô-tô", "Xe máy", "Xe đạp điện", "Xe đạp", "Xe bus", "Metro", "Dịch vụ gọi xe", "Đi bộ"
                  ]}
                  onChange={(value) => {
                    console.log("Phương tiện được chọn:", value);
                    if (value === "Xe máy" || value === "Ô-tô") {
                      setUsedMRT1(true);
                    } else {
                      setUsedMRT1(false);
                    }
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>





        {(isUsedMRT || isUsedMRT1) && (
          <div>
            <RadioGroupAnswerQuestion
              majorIndex={majorIndex}
              mirrorIndex={2}
              showType={"row"}

              question={"Tuổi thọ phương tiện (năm)?"}
              rawQuestion={"Tuổi thọ phương tiện (năm)?"}
              answers={[
                "1-5 ", "6-10 ", "10-15 ", "> 15"
              ]}
            />
            <RadioGroupAnswerQuestion
              majorIndex={majorIndex}
              mirrorIndex={3}
              showType={"row"}

              question={"Ước tính số km phương tiện đã chạy?"}
              rawQuestion={"Ước tính số km phương tiện đã chạy?"}
              answers={[
                "0-10,000 ", " 10,001-20,000 ", " 20,001-50,000 ", " 50,001-100,000 ", " >100,000"
              ]}
            />

          </div>
        )}

        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={4}
          question={"Tần suất di chuyển bằng phương tiện nêu trên (ngày/tuần)? "}
        />

        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={truoc}
                  rawQuestion="Tần suất di chuyển bằng phương tiện nêu trên (ngày/tuần)? (TRƯỚC)"
                  answers={[
                    "1-2", "3-4", "5-6", "7"
                  ]}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={sau}
                  rawQuestion="Tần suất di chuyển bằng phương tiện nêu trên (ngày/tuần)? (SAU)"
                  answers={[
                    "1-2", "3-4", "5-6", "7"

                  ]}
                />
              </td>
            </tr>
          </tbody>
        </table>





        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={5}
          question={"Số chuyến đi chính trung bình hàng ngày bằng phương tiện trên (chuyến/ngày)?"}
        />

        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={truoc}
                  rawQuestion={"Số chuyến đi chính trung bình hàng ngày (chuyến/ngày)? (TRƯỚC)"}
                  answers={[
                    "1-3", "4-6", "7-9", "10 hoặc nhiều hơn"
                  ]}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={sau}
                  rawQuestion={"Số chuyến đi chính trung bình hàng ngày (chuyến/ngày)? (SAU)"}
                  answers={[
                    "1-3", "4-6", "7-9", "10 hoặc nhiều hơn"
                  ]}
                />
              </td>
            </tr>
          </tbody>
        </table>



        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={6}
          question={"Ước tính khoảng cách di chuyển trung bình mỗi chuyến đó?"}
        />

        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <InputNumberQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  question={truoc}
                  rawQuestion={
                    "Ước tính khoảng cách di chuyển trung bình mỗi chuyến đó? (TRƯỚC)"
                  }
                  unit={"km"}
                  min={0}
                  max={1000}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <InputNumberQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  question={sau}
                  rawQuestion={
                    "Ước tính khoảng cách di chuyển trung bình mỗi chuyến đó? (SAU)"
                  }
                  unit={"km"}
                  min={0}
                  max={1000}
                />
              </td>
            </tr>
          </tbody>
        </table>




        <i>Lưu ý: Tính cả khoảng cách trung chuyển, nếu di chuyển bằng phương tiện công cộng</i>

        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={7}
          question={"Ước tính thời gian di chuyển trung bình mỗi chuyến đó?"}
        />

        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <InputNumberQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  question={truoc}
                  rawQuestion={
                    "Ước tính thời gian di chuyển trung bình mỗi chuyến đó? (TRƯỚC)"
                  }
                  unit={"phút"}
                  min={0}
                  max={1000}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <InputNumberQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  question={sau}
                  rawQuestion={
                    "Ước tính thời gian di chuyển trung bình mỗi chuyến đó? (SAU)"
                  }
                  unit={"phút"}
                  min={0}
                  max={1000}
                />
              </td>
            </tr>
          </tbody>
        </table>






        <i>Lưu ý: Tính cả thời gian trung chuyển, nếu di chuyển bằng phương tiện công cộng</i>

        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={8}
          question={"Số chuyến di chuyển trung bình hàng ngày bằng phương tiện cá nhân (ô-tô, xe máy), nếu có?"}
        />

        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={truoc}
                  rawQuestion={"Số chuyến di chuyển trung bình hàng ngày bằng phương tiện cá nhân (ô-tô, xe máy), nếu có? (TRƯỚC)"}
                  answers={[
                    "1-3", "4-6", "7-9", "10 hoặc nhiều hơn"
                  ]}
                />
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <RadioGroupAnswerQuestion
                  majorIndex={undefined}
                  mirrorIndex={undefined}
                  showType={"row"}

                  question={sau}
                  rawQuestion={"Số chuyến di chuyển trung bình hàng ngày bằng phương tiện cá nhân (ô-tô, xe máy), nếu có? (SAU)"}
                  answers={[
                    "1-3", "4-6", "7-9", "10 hoặc nhiều hơn"
                  ]}
                />
              </td>
            </tr>
          </tbody>
        </table>










        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>
      <br />
      <br />
      <br />
    </div>
  );
};
